/**
 * Cookie consent banner — LFPDPPP compliant with sarcastic Quitamelo tone.
 */
import React from 'react';
import { Cookie } from 'lucide-react';
import { useCookieConsent } from '../hooks/useCookieConsent';
import './CookieConsentBanner.css';

const CookieConsentBanner = () => {
  const { showBanner, acceptAll, rejectAll } = useCookieConsent();

  if (!showBanner) return null;

  return (
    <div
      className="cookie-banner"
      role="dialog"
      aria-live="polite"
      aria-label="Aviso de cookies"
      data-testid="cookie-consent-banner"
    >
      <div className="cookie-banner-inner">
        <div className="cookie-banner-icon" aria-hidden="true">
          <Cookie className="w-6 h-6" />
        </div>

        <div className="cookie-banner-content">
          <h3 className="cookie-banner-title">Sí, también usamos cookies 🍪</h3>
          <p className="cookie-banner-text">
            Usamos cookies para entender cómo navegas y mejorar la página. Si aceptas, sabemos qué te late.
            Si no, también está bien — pero después no andes diciendo que "nada funciona como esperabas". 😏
            Consulta nuestro{' '}
            <a
              href="/aviso-de-privacidad"
              className="cookie-banner-link"
              data-testid="cookie-banner-privacy-link"
            >
              Aviso de Privacidad
            </a>.
          </p>
        </div>

        <div className="cookie-banner-actions">
          <button
            type="button"
            className="cookie-btn cookie-btn-secondary"
            onClick={rejectAll}
            data-testid="cookie-banner-reject-button"
          >
            Solo necesarias
          </button>
          <button
            type="button"
            className="cookie-btn cookie-btn-primary"
            onClick={acceptAll}
            data-testid="cookie-banner-accept-button"
          >
            Aceptar todas
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
